import { render, staticRenderFns } from "./add-edit-mesa-votacion.vue?vue&type=template&id=89e85d8e&"
import script from "./add-edit-mesa-votacion.vue?vue&type=script&lang=js&"
export * from "./add-edit-mesa-votacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports